import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { TroubleShootingApp } from './troubleshooting.component';
import { VcaAlertsService } from '../../../common/vca-alerts';
import { AppState } from '../../../app/app.service';
import { AuthService } from '../../../app/auth/auth.service';
import { TroubleshootingService } from './troubleshooting.service';
import { AlarmsNotifierService } from '../../../app/services/alarm-notifier.service';

import '../../../styles/styles.scss';
import { RouterModule } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { NspUpgradeService } from '../../../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ClarityModule.forRoot(),
    VcaCommonModule,
    FormsModule,
    RouterModule.forRoot([]),
    HttpModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) =>
              new TranslateHttpLoader(http, 'assets/i18n/app/', '.json'),
          deps: [HttpClient]
      }
  })
  ],
  declarations: [
    TroubleShootingApp
  ],
  providers: [
    AppState,
    LocalStorageService,
    AuthService,
    Title,
    TroubleshootingService,
    AlarmsNotifierService,
    NspUpgradeService
  ],
  bootstrap: [ TroubleShootingApp ],

})
export class TroubleShootingAppModule {
}



// WEBPACK FOOTER //
// ./src/troubleshooting/src/troubleshooting-ui/troubleshooting.module.ts